<template>
    <div class="bg-White">
        <Mainlayout></Mainlayout>
        <CCol sm="12" lg="12" class="mx-auto" style="width: 100%; background-size: cover; color: #fff;">
    
            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff" class="p-3">
                <CRow class="mt-2 mt-2 ml-3 mr-3">
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <CCard class="b-20 text-black">
                                <div class="text-left">
                                    <CButton type="button" class="btn color-blue float-left" @click="GoToCourse()">
                                        <img style="width:20px" src="../assets/img/arrow-left.png" /> </CButton>
                                </div>
    
                                <h3 class="text-black text-center poppin-text mt-4 ml-3 custom-header-form">Upload BootCamp</h3>
                                <p class="m-3 custom20px-400">
                                    Thank you for your interest in adding a new bootcamp to our list! <br /> Please fill out the following details to provide information about the bootcamp</p>
                                <CCol sm="12" lg="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                                    <CRow>
                                        <CCol sm="12">
                                            <label class="text-black custom-title-form">Title</label>
                                            <input type="text" v-model="Title" class="custom-input-app" placeholder="eg. Bahasa Melayu Tahun 4" />
    
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Level</label>
                                            <v-select v-model="SelectedLevel" :options="levelOption" label="levelName" placeholder="--Please Select Level--">
                                                </v-select>
                                            <!-- <select v-model="SelectedLevel" class="custom-input-app">
                                                    <option value="" disabled selected>Please Select</option>
    <option v-for="option in levelOption" :key="option" :value="option.levelName">{{ option.levelName }}</option>
    </select> -->
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Count Star</label>
                                            <input type="text" v-model="CountStar" placeholder="eg. 5" class="custom-input-app" />
                                        </CCol>
    
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Normal Price</label>
                                            <input type="text" v-model="NormalPrice" placeholder="eg. 120.00" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Discount Price</label>
                                            <input type="text" v-model="DiscountPrice" placeholder="eg. 90.00" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Location</label>
                                            <input type="text" v-model="Location" placeholder="eg. Kuala Lumpur" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Country</label>
                                            <v-select v-model="SelectedCountry" :options="country" label="CountryName" placeholder="--Please Select Country--">
                                                </v-select>
    
                                            <!-- <select v-model="SelectedCountry" class="custom-input-app">
                                                    <option value="" disabled selected>Please Select</option>
    <option v-for="option in country" :key="option" :value="option.Id">{{ option.CountryName }}</option>
    </select> -->
                                        </CCol>

                                        <CCol sm="12" class="mt-3">
                                                    <label class="text-black custom-title-form">URL Billpliz</label>
                                                    <input type="text" v-model="UrlBillPlizz" placeholder="eg. http://www.registerbootcamp.com" class="custom-input-app" />
                                                </CCol>
    
                                        <CCol sm="12" class="mt-3">
                                            <label class="text-black custom-title-form">Teacher</label>
                                            <v-select v-model="SelectedTeacher" :options="teachers" label="name" placeholder="--Please Select Teacher--" required></v-select>
   
    
                                            <!-- <select v-model="SelectedTeacher" class="custom-input-app">
                                                    <option value="" disabled selected>Please Select</option>
    <option v-for="option in teachers" :key="option" :value="option.teacherId">{{ option.name }}</option>
    </select> -->
                                        </CCol>
    
    
                                        <CCol sm="12" class="mt-4">
                                            <CCard class="card-grey">
                                                <span class="text-black custom-btn-table" @click="AddHashtag"> <img style="width:20px" src="../assets/img/Plus.png"/>  Add Hashtag</span>
    
                                                <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
    
                                                   
                                                    <tbody>
                                                        <tr v-for="(item, index) in finalhash" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Hashtag" placeholder="#hashtag" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
    
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowHashtag(index)" />
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr v-for="(item, index) in hashes" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Hashtag" placeholder="#hashtag" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
    
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowHashtag(index)" />
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </CCard>
                                        </CCol>
    
                                        <CCol sm="12" class="mt-2">
                                            <CCard class="card-grey mt-3">
                                                <span class="text-black custom-btn-table" @click="AddDetail"> <img style="width:20px" src="../assets/img/Plus.png"/>  Add Highlight Bootcamp</span>
    
    
                                                <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                                    
                                                    <tbody>
                                                        <tr v-for="(item, index) in finalhighlight" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Kuasai Sifir - Darab & Bahagi" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowDetail(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr v-for="(item, index) in highlight" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Kuasai Sifir - Darab & Bahagi" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowDetail(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </CCard>
                                        </CCol>
    
                                        <CCol sm="12" class="mb-2">
                                            <CCard class="card-grey mt-3">
                                                <span class="text-black custom-btn-table" @click="AddRequirement"><img style="width:20px" src="../assets/img/Plus.png"/>  
                                                     Add Requirement
                                                </span>
    
                                                <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                                    
                                                    <tbody>
                                                        <tr v-for="(item, index) in finalreq" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Berumur 9 hingga 12 tahun (Darjah 3 hingga 6)" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowRequire(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr v-for="(item, index) in req" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Berumur 9 hingga 12 tahun (Darjah 3 hingga 6)" class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowRequire(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </CCard>
                                        </CCol>
    
                                        <CCol sm="12" class="mb-2">
                                            <CCard class="card-grey mt-3">
                                                <span class="text-black custom-btn-table" @click="AddLearning" size="sm">
                                                    <img style="width:20px" src="../assets/img/Plus.png"/> Add What You Will Be Learn
                                                </span>
    
                                                <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                                    <tbody>
                                                        <tr v-for="(item, index) in finallearn" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Kuasai sifir dengan cepat dan mudah tanpa tekanan." class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowLearn(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                    <tbody>
                                                        <tr v-for="(item, index) in learn" v-bind:key="item.Id">
                                                            <td>
                                                                <input type="text" v-model="item.Description" placeholder="Kuasai sifir dengan cepat dan mudah tanpa tekanan." class="custom-input-app bg-white" />
                                                            </td>
                                                            <td style="width:10%">
                                                                <img style="width:20px" src="../assets/img/trash.png" v-on:click="removeRowLearn(index)">
    
                                                            </td>
    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </CCard>
                                        </CCol>
    
                                        <CCol sm="12">
                                            <label class="text-black custom-title-form">Synopsis</label>
                                            <tinymce id="d1" v-model="Synopsis" placeholder="Enter Your Question"></tinymce>
                                        </CCol>

                                        <CCol sm="12">
                                            <label class="text-black custom-title-form">Description</label>
                                            <tinymce id="d2" v-model="Description" placeholder="Enter Your Question"></tinymce>
                                        </CCol>
    
    
                                        <CCol sm="12" class="mt-4">
                                            <label class="text-black custom-title-form">Upload Thumbnail</label>
                                            <br />
                                            <input type="file" id="thumbnail" ref="mythumbnail" @change="onFileChangeThumbnail" />
    
                                            <div id="preview">
                                                <img style="max-width: 200px" v-if="urlThumbnail" :src="urlThumbnail" />
                                            </div>
                                            <img v-if="FilePath != null" :src="getThumbnail(FilePath)" style="max-width: 100px;border-radius:20px"/>
                                <img v-else src="../assets/img/C1.png" class="custom-bg-advetise" style="border-radius:20px" />
                                        </CCol>
                                        <CCol sm="12">
                                            <div v-if="SuccessMessage == true" class="mt-3">
                                                <CAlert show color="success">Successfully to Save Detail Bootcamp</CAlert>
                                            </div>
                                        </CCol>
    
                                        <div v-if="SubmittedForm === true">
                                            <label>Loading....</label>
                                        </div>
    
                                        <CButton type="button" class="bg-button-blue text-white m-2" block :disabled="isDisabled" @click="InsertVideoData">Submit</CButton>
     
    
                                    </CRow>
                                    <br /><br />
                                </CCol>
                            </CCard>
                            <br /><br />
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
            <br /><br /><br />
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);
import _ from "lodash";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
           
            thumbnail: [],
            
            levelOption: [{
                    id: 1,
                    levelName: 'Beginner'
                },
                {
                    id: 2,
                    levelName: 'Intermediate'
                },
                {
                    id: 1,
                    levelName: 'Advanced'
                }
            ],

            SelectedCountry: {},
            SelectedLevel: {},
            SelectedTeacher: {},

            Location: "",
            DiscountPrice: "",
            Description: "",
            NormalPrice: "",
            CountStar: 0,
            Title: "",
            Synopsis: "",
            UrlBillPlizz: "",
            FilePath: "",

            SuccessMessage: false,
            teachers: [],
            country: [],

            finalhash: {},
            hashes: [],

            finalhighlight: {},
            highlight: [],

            finalreq: {},
            req: [],

            finallearn: {},
            learn: [],

            urlThumbnail: null,

SuccessMessage: false,
studentProfileAuthorize: {},
SubmittedForm: false,
backgroundUrl,




        };
    },
    created() {
        AOS.init();
    },
    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();

            this.GetListBootcamp();
            this.GetCountry();
         this.GetTeacherName();
        } else {
            this.GoToLogin();
        }
    },

    methods: {
        AddHashtag() {
            var lastId = 1;
            var length = this.hashes.length;
            if (length > 0) lastId = this.hashes[length - 1].Id;

            this.hashes.push({
                Id: lastId + 1,
                Name: "",
            });
        },
        removeRowHashtag: function(index) {
            this.hashes.splice(index, 1);
        },
        AddDetail() {
            var lastId = 1;
            var length = this.highlight.length;
            if (length > 0) lastId = this.highlight[length - 1].Id;

            this.highlight.push({
                Id: lastId + 1,
                Description: "",
            });
        },
        removeRowDetail: function(index) {
            this.highlight.splice(index, 1);
        },
        AddRequirement() {
            var lastId = 1;
            var length = this.req.length;
            if (length > 0) lastId = this.req[length - 1].Id;

            this.req.push({
                Id: lastId + 1,
                Description: "",
            });
        },
        removeRowRequire: function(index) {
            this.req.splice(index, 1);
        },
        AddLearning() {
            var lastId = 1;
            var length = this.learn.length;
            if (length > 0) lastId = this.learn[length - 1].Id;

            this.learn.push({
                Id: lastId + 1,
                Description: "",
            });
        },
        removeRowLearn: function(index) {
            this.learn.splice(index, 1);
        },
        
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetail, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                    }
                });
        },
        GetTeacherName() {
            this.$API
                .get(this.$GetListteacher, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.teachers = response.data;
                    }
                });
        },
        async GetCountry() {
            try {
                const response = await this.$API.get(this.$ListCountry);
                if (response.status === 200 && response.data) {
                    this.info = response.data;
                    this.country = this.info; // Populate the country list\
                }
            } catch (error) {
                console.error('Error fetching country data:', error);
            }
        },
        GetAuthorizeProfile() {
            this.$API
                .get(this.$PickiddoUserProfile + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL = this.studentProfileAuthorize.filePath;
                    }
                });
        },

        getThumbnail(FilePath) {
            return (
                "https://d3us0m7iuwh1d3.cloudfront.net/" + FilePath
            );
        },
        GetListBootcamp() {
            return this.$API.get(this.$GetListBootcampByIdFirst + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    this.info = response.data;
                    if (response.status == 200 && this.info != null) {
                        this.Title = this.info.Title;
                        this.CountStar = this.info.CountStar;
                        this.NormalPrice = this.info.NormalPrice;

                        this.DiscountPrice = this.info.DiscountPrice;
                        this.Location = this.info.Location;
                        this.Country = this.info.Country;
                        this.Level = this.info.Level;
                        this.Synopsis = this.info.Synopsis;
                        this.Teacher = this.info.Teacher;
                        this.Bootcampid = this.info.Bootcampid;
                        this.UrlBillPlizz = this.info.UrlBillPlizz;
                        this.Description = this.info.Description;
                        this.FilePath = this.info.FilePath;
                        this.Uid = this.info.Id;
                        this.ThumbnailId = this.info.ThumbnailId;
                        this.GetHashTag(this.Bootcampid);
                        this.GetHighlight(this.Bootcampid);
                        this.GetRequirement(this.Bootcampid);
                        this.GetWhatYouLearn(this.Bootcampid);


                        this.SetupSelectedOption();
                        this.getThumbnail(this.FilePath);
                    } else {
                        console.log(this.info.detail);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.status);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";
                    }
                });
        },
        SetupSelectedOption() {
            console.log("test" + this.Country);
            this.SelectedLevel = _.find(this.levelOption, {
                levelName: this.Level,
            });

            this.SelectedCountry = _.find(this.country, {
                CountryName: this.Country,
            });

            this.SelectedTeacher = _.find(this.teachers, {
                name: this.Teacher,
            });
        },

        GetHashTag(Bootcampid) {
            console.log("test" + Bootcampid);
            this.$API
                .get(this.$GetHashTag + "?id=" + Bootcampid, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.finalhash = response.data;
                    }
                });
        },

        GetHighlight(Bootcampid) {
            console.log("test" + Bootcampid);
            this.$API
                .get(this.$GetHighlight + "?id=" + Bootcampid, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.finalhighlight = response.data;
                    }
                });
        },
        GetRequirement(Bootcampid) {
            console.log("test" + Bootcampid);
            this.$API
                .get(this.$GetRequirement + "?id=" + Bootcampid, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.finalreq = response.data;
                    }
                });
        },
        GetWhatYouLearn(Bootcampid) {
            console.log("test" + Bootcampid);
            this.$API
                .get(this.$GetWhatYouLearn + "?id=" + Bootcampid, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.finallearn = response.data;
                    }
                });
        },

        InsertVideoData() {
            console.log("test" + this.SelectedLevel);
            this.SubmittedForm = true;
            const formData = new FormData();
            formData.append("Title", this.Title);
            formData.append("Level", this.SelectedLevel.levelName);
            formData.append("CountStar", this.CountStar);
            formData.append("NormalPrice", this.NormalPrice);
            formData.append("DiscountPrice", this.DiscountPrice);
            formData.append("Location", this.Location);
            formData.append("CountryId", this.SelectedCountry.Id);





            formData.append("UrlBillPlizz", this.UrlBillPlizz);
            formData.append("Description", this.Description);
            formData.append("Synopsis", this.Synopsis);
            formData.append("Id", this.Bootcampid);
            formData.append("UId", this.Uid);


            var combinedHash = [];
                for (let i in this.hashes) {
                let item = this.hashes[i];

                combinedHash.push({
                    Bootcampid: 1,
                    Hashtag: item.Hashtag,
                });
            }

                for (let i in this.finalhash) {
                let item = this.finalhash[i];

                combinedHash.push({
                    Bootcampid: item.Bootcampid,
                    Hashtag: item.Hashtag,
                });
            }
            let hashJson = JSON.stringify(combinedHash);
            formData.append("hashtagJson", hashJson);


            var combinedHighlight = [];
                for (let i in this.highlight) {
                let item = this.highlight[i];

                combinedHighlight.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }

                for (let i in this.finalhighlight) {
                let item = this.finalhighlight[i];

                combinedHighlight.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }
            var detailJson = JSON.stringify(combinedHighlight);
            formData.append("highlightJson", detailJson);

            var combinedLearn = [];
                for (let i in this.learn) {
                let item = this.learn[i];

                combinedLearn.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }

                for (let i in this.finallearn) {
                let item = this.finallearn[i];

                combinedLearn.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }


            var learnJson = JSON.stringify(combinedLearn);
            formData.append("learningJson", learnJson);

            var combinedRequirement = [];
                for (let i in this.req) {
                let item = this.req[i];

                combinedRequirement.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }

                for (let i in this.finalreq) {
                let item = this.finalreq[i];

                combinedRequirement.push({
                    Bootcampid: item.Bootcampid,
                    Description: item.Description,
                });
            }

            var requireJson = JSON.stringify(combinedRequirement);
            formData.append("requirementJson", requireJson);

           
                formData.append("TeacherId", this.SelectedTeacher.teacherId);
           

            if(this.thumbnail[0] == undefined)
            {
                formData.append("ThumbnailId", this.ThumbnailId);
            }
            else
            {
                formData.append("thumbnail", this.thumbnail[0]);
            }
            

            return this.$API
                .post(this.$UploadBootcamp, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status == 200) {
                        this.SuccessMessage = true;
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onFileChangeVideo(e) {
            const file = e.target.files[0];
            this.urlVideo = URL.createObjectURL(file);
            this.HandleFileInputVideo();
        },
        HandleFileInputVideo() {
            console.log(this.$refs.myvideo.files);
            this.video = this.$refs.myvideo.files;
            //this.SubmitFileApplicationDescription1();
        },
        onFileChangeThumbnail(e) {
            const file = e.target.files[0];
            this.urlThumbnail = URL.createObjectURL(file);
            this.HandleFileInputThumbnail();
        },
        HandleFileInputThumbnail() {
            console.log(this.$refs.mythumbnail.files);
            this.thumbnail = this.$refs.mythumbnail.files;
            //this.SubmitFileApplicationDescription1();
        },
        onFileChangeBanner(e) {
            const file = e.target.files[0];
            this.urlBanner = URL.createObjectURL(file);
            this.HandleFileInputBanner();
        },
        HandleFileInputBanner() {
            console.log(this.$refs.mybanner.files);
            this.banner = this.$refs.mybanner.files;
            //this.SubmitFileApplicationDescription1();
        },


    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat');
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-tab .nav-link.active {
    border-bottom: 2px solid #000;
    /* Replace with your desired border color */
}
</style>